export default ms =>
  new Promise(resolve => (ms ? setTimeout(resolve, ms) : resolve()))
